// import { createUserWithEmailAndPassword,updateProfile } from "@firebase/auth";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Redirect } from "react-router";
import { doc, getDoc, setDoc } from "@firebase/firestore";
import { Link } from "react-router-dom";
import { login } from "../../features/user/userSlice";
import {auth,db} from "../../firebase"
import Button from "../button/Button";
import PageHeader from "../page-header/PageHeader";
import "../login/login.scss";
import { createUserWithEmailAndPassword, updateProfile } from "@firebase/auth";
import { notify } from "../notify/Notify";
export default function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();

  const registerHandler = async (e) => {
    e.preventDefault();
    try {
      console.log(name);
      const { user } = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );
        
      await updateProfile(user, { displayName: name });
      await setDoc(doc(db, "users", user.uid), {
        email: user.email,
        uid: user.uid,
        displayName: name,
        bookingList: [],
        
      });
       const userDb = await getDoc(doc(db, "users", user.uid));
       const { bookingList } = userDb.data();
      dispatch(
        login({
          email: user.email,
          uid: user.uid,
          displayName: name,
          bookingList,
        })
      );
      return <Redirect to="/" />;
    } catch (err) {
     notify(err.message);
    }
  };
  return (
    <>
      <PageHeader>Register</PageHeader>
      <div className="container">
        <div className="section mb-3">
          <form  onSubmit={registerHandler} id="register">
            <div className="form__control">
              <label htmlFor="name">Name</label>
              <input
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Steve Jones"
                name="name"
                type="text"
              />
            </div>
            <div className="form__control">
              <label htmlFor="email">Email</label>
              <input
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="example@email.com"
                name="email"
                type="email"
              />
            </div>
            <div className="form__control">
              <label htmlFor="password">Password</label>
              <input
                required
                onChange={(e) => setPassword(e.target.value)}
                value={password}
                placeholder="********"
                name="password"
                type="password"
              />
            </div>
            <Button className="register__btn" type="submit">
              Register
            </Button>
            <Link to="/login">Login if you have an account</Link>
          </form>
        </div>
      </div>
    </>
  );
}
